import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AsideDrawerStyles,
  BackDrop,
  LinkButtonStyles,
  LinkPopupContainer,
  DescriptionSpanStyles
} from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/linkPopup.style';
import { LinkPopupAml } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupAml/linkPopupAml';
import { AsideDrawer } from '@single-platform/components';
import { LinkPopupDescription } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupDescription/linkPopupDescription';
import { LinkPopupDataExchange } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupDataExchange/linkPopupDataExchange';
import { LinkPopupFatca } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupFatca/linkPopupFatca';
import { LinkPopupWhoIsPep } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupWhoIsPep/linkPopupWhoIsPep';
import { LinkPopupFarmPartners } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupFarmPartners/linkPopupFarmPartners';
import { LinkPopupNaceCodes } from '@applicationKYC/LegalEntityQuestionnaire/components/linkPopup/drawers/linkPopupNaceCodes/linkPopupNaceCodes';

export const LinkPopup = ({ group, isInModal, farmers }) => {
  const [rightSideDrawerOpen, setRightSideDrawerOpen] = useState(false);
  const { t } = useTranslation();

  const handleDrawerClose = () => {
    setRightSideDrawerOpen(false);
  };

  const getLinkPopupContent = (linkPopUpKey) => {
    switch (linkPopUpKey) {
      case 'link_popup_aml':
        return <LinkPopupAml onClose={handleDrawerClose} header={group.text} />;
      case 'link_popup_farm_partners':
        return <LinkPopupFarmPartners onClose={handleDrawerClose} header={group.text} />;
      case 'link_popup_activity':
        return (
          <LinkPopupDescription onClose={handleDrawerClose} header={group.text} farmers={farmers} />
        );
      case 'link_popup_data_exchange':
        return <LinkPopupDataExchange onClose={handleDrawerClose} header={group.text} />;
      case 'link_popup_who_is_pep':
        return <LinkPopupWhoIsPep onClose={handleDrawerClose} header={group.text} />;
      case 'link_popup_fatca':
        return <LinkPopupFatca onClose={handleDrawerClose} header={group.text} />;
      case 'link_popup_nace_codes':
        return <LinkPopupNaceCodes onClose={handleDrawerClose} />;
      default:
        return;
    }
  };

  useEffect(() => {
    if (rightSideDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [rightSideDrawerOpen]);

  return (
    <LinkPopupContainer>
      {group.description && <DescriptionSpanStyles>{t(group.description)}</DescriptionSpanStyles>}
      <LinkButtonStyles onClick={() => setRightSideDrawerOpen(!rightSideDrawerOpen)}>
        {t(group.text)}
      </LinkButtonStyles>

      {rightSideDrawerOpen && !isInModal && <BackDrop onClick={handleDrawerClose} />}

      <AsideDrawerStyles isInModal={isInModal}>
        <AsideDrawer
          isOpen={rightSideDrawerOpen}
          id={'scrollable-content'}
          activeIndex={isInModal && rightSideDrawerOpen ? 1 : isInModal && 0}
        >
          {getLinkPopupContent(group.popupKey)}
        </AsideDrawer>
      </AsideDrawerStyles>
    </LinkPopupContainer>
  );
};
